import {
    REGISTER_REQUEST,
    REGISTER_SUCCESS,
    REGISTER_FAILURE,

    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,

    VERIFY_OTP_REQUEST,
    VERIFY_OTP_SUCCESS,
    VERIFY_OTP_FAILURE,

    PASSWORD_RESET_REQUEST,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_FAILURE,

    PASSWORD_RESET_CONFIRM_REQUEST,
    PASSWORD_RESET_CONFIRM_SUCCESS,
    PASSWORD_RESET_CONFIRM_FAILURE,

    ACTIVATE_ACCOUNT_REQUEST,
    ACTIVATE_ACCOUNT_SUCCESS,
    ACTIVATE_ACCOUNT_FAILURE,

    REQUEST_ACCOUNT_DELETION_REQUEST,
    REQUEST_ACCOUNT_DELETION_SUCCESS,
    REQUEST_ACCOUNT_DELETION_FAILURE,

    CHECK_EMAIL_REQUEST,
    CHECK_EMAIL_SUCCESS,
    CHECK_EMAIL_FAILURE,

    LOGOUT,
} from "../actions/types";
import * as types from
    "../actions/types";

const token =
    localStorage.getItem(
        "access_token"
    );

const initialState = {
    user: null,

    accessToken:
        token,

    isAuthenticated:
        !!token,

    loading: false,

    error: null,

    registrationData:
        null,

    otpVerificationData:
        null,

    passwordResetData:
        null,
    updatingProfile:
            false,
    profileUpdateError:
            null,
    deletingAccount: false,
    deleteAccountError: null,
    deleteAccountSuccess: false,
    checkingEmail: false,
    emailAvailable: null,
    emailCheckError: null,
};

const authReducer = (
    state = initialState,
    action
) => {
    switch (
        action.type
    ) {
       
        case REGISTER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case REGISTER_SUCCESS:
            return {
                ...state,
                loading: false,
                registrationData:
                    action.payload,
            };

        case REGISTER_FAILURE:
            return {
                ...state,
                loading: false,
                error:
                    action.payload,
            };

     
        case LOGIN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,

                user:
                    action.payload
                        ?.user ||
                    null,

                accessToken:
                    action.payload
                        ?.access_token ||
                    null,

                isAuthenticated:
                    true,
            };

        case LOGIN_FAILURE:
            return {
                ...state,
                loading: false,

                error:
                    action.payload,

                isAuthenticated:
                    false,
            };

     
        case VERIFY_OTP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case VERIFY_OTP_SUCCESS:
            return {
                ...state,
                loading: false,
                otpVerificationData:
                    action.payload,
            };

        case VERIFY_OTP_FAILURE:
            return {
                ...state,
                loading: false,
                error:
                    action.payload,
            };

     
        case PASSWORD_RESET_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                loading: false,
                passwordResetData:
                    action.payload,
            };

        case PASSWORD_RESET_FAILURE:
            return {
                ...state,
                loading: false,
                error:
                    action.payload,
            };

     
        case PASSWORD_RESET_CONFIRM_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case PASSWORD_RESET_CONFIRM_SUCCESS:
            return {
                ...state,
                loading: false,
            };

        case PASSWORD_RESET_CONFIRM_FAILURE:
            return {
                ...state,
                loading: false,
                error:
                    action.payload,
            };
        case types.UPDATE_PROFILE_REQUEST:
            return {
                ...state,
                updatingProfile:
                    true,
                profileUpdateError:
                    null,
            };

        case types.UPDATE_PROFILE_SUCCESS:
            return {
                ...state,
                updatingProfile:
                    false,
                profileUpdateError:
                    null,
            };

        case types.UPDATE_PROFILE_FAILURE:
            return {
                ...state,
                updatingProfile:
                    false,
                profileUpdateError:
                    action.payload,
            };

        case types.CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case types.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };

        case types.CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                error:
                    action.payload,
            };

        case ACTIVATE_ACCOUNT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case ACTIVATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };

        case ACTIVATE_ACCOUNT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case REQUEST_ACCOUNT_DELETION_REQUEST:
    return {
        ...state,
        deletingAccount: true,
        deleteAccountError: null,
        deleteAccountSuccess: false,
    };

        case REQUEST_ACCOUNT_DELETION_SUCCESS:
            return {
                ...state,
                deletingAccount: false,
                deleteAccountError: null,
                deleteAccountSuccess: true,
            };

        case REQUEST_ACCOUNT_DELETION_FAILURE:
            return {
                ...state,
                deletingAccount: false,
                deleteAccountError:
                    action.payload,
                deleteAccountSuccess: false,
            };

        case CHECK_EMAIL_REQUEST:
            return {
                ...state,
                checkingEmail: true,
                emailAvailable: null,
                emailCheckError: null,
            };

        case CHECK_EMAIL_SUCCESS:
            return {
                ...state,
                checkingEmail: false,
                emailAvailable:
                    action.payload?.available ?? null,
                emailCheckError: null,
            };

        case CHECK_EMAIL_FAILURE:
            return {
                ...state,
                checkingEmail: false,
                emailAvailable: null,
                emailCheckError:
                    action.payload,
            };
        case LOGOUT:
            localStorage.removeItem(
                "access_token"
            );

            return {
                ...initialState,
                user: null,
                accessToken:
                    null,
                isAuthenticated:
                    false,
            };

        default:
            return state;
    }
};

export default authReducer;